import { DealActions, DealSubscriptionIdentifier, EntityTypeEnum, SubscriptionIdentifier } from 'api'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createDealDetailsSelector } from 'selectors/dealSelectors'
import { createEntitySubscriptionSelector } from 'selectors/selectionSelectors'
import { AdvancedDealSubscriptionFilters } from 'view/components/datagrid/filters/AdvancedDealSubscriptionFilters'
import { DealsScreenBase } from './components/DealsScreenBase/DealsScreenBase'
import { DealsHeroPanelBase } from './components/DealsScreenBase/DealsHeroPanelBase'
import { Translation } from 'locale'
import { GridActions, GridId } from 'store/grid'
import { ExtractReportButton } from './components/ExtractReportButton'
import { ColumnCopySelector } from '../requests/incoming/components/ColumnCopySelector'
import { GridApi } from 'ag-grid-community'
import { generateExportFileName } from 'view/components/datagrid/gridUtils/utils'

const dealDetailsSelector = createDealDetailsSelector([DealSubscriptionIdentifier.BLOTTER])
const subscriptionDetailDealsScreenSelector = createEntitySubscriptionSelector(
  () => EntityTypeEnum.DEAL,
  () => SubscriptionIdentifier.BLOTTER
)

export const DealsScreen = () => {
  const dispatch = useDispatch()
  const dealDetails = useSelector(dealDetailsSelector)
  const subscriptionDetail = useSelector(subscriptionDetailDealsScreenSelector)

  const onPageChanged = (pageNumber: number) => {
    if (subscriptionDetail) {
      dispatch(DealActions.pageSubscribe(SubscriptionIdentifier.BLOTTER, subscriptionDetail.filters, pageNumber))
    }
  }

  const handleAfterRestoreDefaultLayout = (_: GridApi) => {
    dispatch(GridActions.saveGridColumnCopySelections(GridId.DealsGrid, 'default', []))
  }

  return (
    <DealsScreenBase
      dealDetails={dealDetails}
      subscriptionDetail={subscriptionDetail}
      subscriptionFilter={<AdvancedDealSubscriptionFilters subscriptionIdentifier={DealSubscriptionIdentifier.BLOTTER} />}
      onPageChanged={onPageChanged}
      gridId={GridId.DealsGrid}
      onAfterRestoreDefaultLayout={handleAfterRestoreDefaultLayout}
      customToolbarButtons={[ExtractReportButton]}
      customToolbarComponents={[ColumnCopySelector]}
      exportFileName={generateExportFileName('Trades')}>
      <DealsHeroPanelBase
        dealList={dealDetails}
        tearoutRoute={'/quote/tearout/trades'}
        heroTitle={Translation.TC_HERO_DEALS}
        bannerTitle={Translation.TC_DEALS}
      />
    </DealsScreenBase>
  )
}
